var isMotionValue = function isMotionValue(value) {
  return value === undefined ? false : !!value.getVelocity;
};

export { isMotionValue };